import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class AuthenticatedTeamsShowProjectsIndexController extends Controller {}
